import Vue from 'vue'
import Vuex from 'vuex'

import account from './modules/account'
import game from './modules/game'

Vue.use(Vuex)

/*
	The boxart store. Two namespaced modules:

	- account — who's signed in (boxart's own session token via the geekgroup
	  OIDC IdP, Google, or passwordless email).
	- game — today's puzzle and the 16-guess reveal mechanic (one tile per
	  wrong guess, hints from the server, per-date localStorage resume).
*/

export default new Vuex.Store({

	modules: {
		account: account,
		game: game
	}

})
